import React, { FC } from 'react';

import ContractTermsAndConditions from 'components/ContractTermsAndConditions';
import SEO from 'components/SEO';

/* A standalone page that renders the contract terms & conditions on their own,
 * so customers can review them (e.g. via the link on the purchase option step)
 * before reaching the acceptance step in the phone purchase flow. */
const ContractTermsView: FC = () => (
  <div
    className="ContractTermsView w100 single-column-content-width-md mxauto px1"
    style={{ paddingTop: '2rem', paddingBottom: '4rem' }}
  >
    <SEO
      title="Contract Terms & Conditions"
      description="The Light Phone Wireless Service and Phone Payment Agreement."
    />
    <ContractTermsAndConditions />
  </div>
);

export default ContractTermsView;
